import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { useViewport } from '@sbt-web/hooks';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
export const useAdvToggle = () => {
  const $ = _c(10);
  const {
    optimizely
  } = useContext(OptimizelySubitoContext);
  const [noAdvToggle, setNoAdvToggle] = useState("A");
  const [optimizelyReady, setOptimizelyReady] = useState(false);
  const {
    isDesktop
  } = useViewport();
  let t0;
  let t1;
  if ($[0] !== isDesktop || $[1] !== optimizely) {
    t0 = () => {
      optimizely?.onReady().then(() => {
        setNoAdvToggle(optimizely.activate(`subito-${isDesktop ? "desktop" : "msite"}-no-adv-flywheel-longterm`) ?? "A");
        setOptimizelyReady(true);
      });
    };
    t1 = [isDesktop, optimizely];
    $[0] = isDesktop;
    $[1] = optimizely;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== noAdvToggle) {
    t2 = () => {
      if (noAdvToggle === "B") {
        document.body.classList.add("hide-lira");
      } else {
        document.body.classList.remove("hide-lira");
      }
    };
    t3 = [noAdvToggle];
    $[4] = noAdvToggle;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== noAdvToggle || $[8] !== optimizelyReady) {
    t4 = {
      noAdvToggle,
      optimizelyReady
    };
    $[7] = noAdvToggle;
    $[8] = optimizelyReady;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};